import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { fadeUp } from '../../utils/motion';
type RelatedInitiativeProps = {
  name: string;
  body: string;
  href: string;
  status?: string;
  label?: string;
  linkLabel?: string;
};
export function RelatedInitiative({
  name,
  body,
  href,
  status,
  label = 'Related initiative',
  linkLabel
}: RelatedInitiativeProps) {
  return <section aria-label={label} className="bg-surface-bg border-t border-line py-14 lg:py-16" data-id="element-1338" data-mp="1gewr0tcuxvei">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 items-center" data-id="element-1339" data-mp="1ldrazymk9q07">
        <div className="lg:col-span-5" data-id="element-1340" data-mp="1v4c63c310ced">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-1341" data-mp="1v7giuxuk4ggn">{label}</p>
          <div className="flex flex-wrap items-center gap-3" data-id="element-1342" data-mp="1z91zmua7pew4">
            <h2 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark tracking-tight" data-id="element-1343" data-mp="245k37qtt376v">{name}</h2>
            {status && <StatusBadge data-id="element-1344" data-mp="1cti0ktjze64n">{status}</StatusBadge>}
          </div>
        </div>
        <div className="lg:col-span-7 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-10" data-id="element-1345" data-mp="18qvaoy6veva3">
          <p className="text-lg text-ink-dark leading-relaxed" data-id="element-1346" data-mp="13r8po2kswaqq">{body}</p>
          <a href={href} className="shrink-0 inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1347" data-mp="yt751d7q83d5">
            {linkLabel ?? `Explore ${name}`}
            <ArrowRight size={16} aria-hidden="true" data-id="element-1348" data-mp="1motdd6btx39r" />
          </a>
        </div>
      </motion.div>
    </section>;
}